import { schemes, zSchema } from "@zeal/common";

export const postYtdSummaryRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  employeeID: zSchema.array(schemes.mongoObjectId()),
  media_type: zSchema.enum(["csv"]),
  year: zSchema.string(),
});

export type TPostYtdSummaryRequestSchema = zSchema.infer<
  typeof postYtdSummaryRequestSchema
>;

export const postYtdSummaryResponseSchema = zSchema.object({
  created_at: zSchema.string(),
  job_id: zSchema.string(),
  status: zSchema.enum(["pending", "completed"]),
});

export type TPostYtdSummaryResponseSchema = zSchema.infer<
  typeof postYtdSummaryResponseSchema
>;
